import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import analyticsRoutes from './analytics/analytics.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as notificationRoutes } from './notifications/routes';
import { routes as inboxRoutes } from './inbox/routes';
import { frontendURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';
import campaignsRoutes from './campaigns/campaigns.routes';
import dashboardAppsRoutes from './dashboard_apps/dashboard_apps.routes';
import kanbanRoutes from './kanban/kanban.routes';
import { routes as aifocusAgentsRoutes } from './aifocus-agents/aifocus.routes';
import { routes as companiesRoutes } from './companies/routes';
import chatRoomsRoutes from '../chatRooms';
import AppContainer from './Dashboard.vue';
import Suspended from './suspended/Index.vue';
// GoogleCalendarOAuthCallback is now handled server-side by google_calendar_oauth_controller.rb

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId'),
      component: AppContainer,
      children: [
        ...analyticsRoutes.routes,
        ...aifocusAgentsRoutes,
        ...contactRoutes,
        ...companiesRoutes,
        ...inboxRoutes,
        ...conversation.routes,
        ...kanbanRoutes.routes,
        ...dashboardAppsRoutes.routes,
        ...settings.routes,
        ...searchRoutes,
        ...notificationRoutes,
        ...helpcenterRoutes.routes,
        ...campaignsRoutes.routes,
        ...chatRoomsRoutes.routes,
        ...(chatRoomsRoutes.settingsRoutes || []),
      ],
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: Suspended,
    },
    // Google Calendar OAuth callback is now handled server-side
  ],
};
